<template>
  <div class="webinars">
    <h3>Upcoming Webinars</h3>
    <p class="loading-notice text-muted" v-if="loading"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading upcoming webinars...</p>
    <div
      class="alert alert-danger"
      role="alert"
      v-if="error">Error loading upcoming webinars. Please refresh the page and try again.</div>
    <ul class="webinar-list" v-if="webinarList && webinarList.length">
      <li
        v-for="webinar, idx in webinarList"
        :key="webinar._id">
        <a
          :href="webinar.url"
          rel="noopener"
          target="_blank"
          @click="trackLinkClick('Clicked Upcoming Webinar', {ref: 'home', title: webinar.title, date: webinar.date, position: idx + 1})">
          <span class="sr-only">Webinar:</span>
          <span>{{ webinar.title }}</span>
          <span class="sr-only">Date: {{ webinar.date }}</span>
          <span class="sr-only">(opens in a new tab)</span>
        </a>
        <span>{{ webinar.date }}</span>
      </li>
    </ul>
    <ul v-else class="webinar-list"><li>No upcoming webinars</li></ul>
    <ul class="view-all-links">
      <li>
        <a
          :href="webinars"
          rel="noopener"
          target="_blank"
          @click="trackLinkClick('Clicked View All Webinars', {ref: 'home'})">
          View all upcoming webinars
          <span class="sr-only">(opens in a new tab)</span>
        </a>
      </li>
      <li>
        <a
          :href="pastWebinars"
          rel="noopener"
          target="_blank">
          View past webinar recordings
          <span class="sr-only">(opens in a new tab)</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { toolkitUrls } from '@/links'
import homeMixin from '@/components/home/mixins'
import { getUpcomingWebinars } from '@/api/webinars'

export default {
    name: 'UpcomingWebinars',
    mixins: [homeMixin],
    data() {
        return {
            loading: true,
            error: false,
            ...toolkitUrls,
            webinarList: null
        }
    },
    methods: {
        async getWebinars() {
            try {
                const data = await getUpcomingWebinars()
                if (data && data.length) {
                    this.updateWebinars(data)
                } else {
                  this.updateWebinars([])
                }
                this.loading = false
            } catch (err) {
                console.error(err)
                this.error = true
                this.loading = false
            }
        },
        updateWebinars(data) {
            this.webinarList = data
      }
    },
    created() {
        this.getWebinars()
    }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

h3 {
    color: @header-text-dark;
    font-size: 1.2rem;
    margin-top: 14px;
}
a:focus {
    outline: 2px solid lighten(@link-color, 20%);;
    outline-offset: 3px;
}
.loading-notice {
  font-size: 1rem;
}
.webinars {
    margin-left: 1rem;
}
.webinar-list {
    list-style: none;
    padding: 0;

    & > li {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;

        & > a {
            font-weight: 500;
            font-size: 1rem;
        }
    }

    & li:last-child {
        margin-bottom: 1rem;
    }
}
.view-all-links {
  list-style-type: none;
  padding: 0;
  & > li {
    margin-bottom: 0.5rem;
  }
}

@media (min-width: @screen-sm) and (max-width: @screen-lg) {
  h3 {
    margin-top: 0;
  }
}

</style>
